import 'react';
import { formatCurrency, formatNumber } from '@atc/string-fns';
import _get from 'lodash/get';
import { fallbackInterestRates } from 'axl-config';
import { Text } from 'reaxl';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
const buildLeaseDisclaimer = (_ref, disclaimerKey) => {
  let {
    acquisitionFee,
    capReduction,
    dealerName = '',
    dueAtSigningValue,
    excessMileageCharge,
    grossCapCost,
    leasePayment,
    make = '',
    programEndDate = '',
    totalOfPayments,
    securityDeposit,
    selectedCreditTier,
    selectedLeaseTerm,
    selectedMileage,
    salePrice,
    lender = '',
    shortCustomDisclaimer = ''
  } = _ref;
  const creditScoreLow = _get(fallbackInterestRates, `${selectedCreditTier}.creditScoreLow`, '');
  let onPageLeaseDisclaimer = /*#__PURE__*/jsxs(Fragment, {
    children: ["Lease payments starting at", /*#__PURE__*/jsx(Text, {
      weight: "bold",
      children: ` ${formatCurrency(Math.floor(leasePayment))}/mo.* `
    }), "for", /*#__PURE__*/jsx(Text, {
      weight: "bold",
      children: ` ${formatNumber({
        value: selectedLeaseTerm
      })} `
    }), "months,", /*#__PURE__*/jsx(Text, {
      weight: "bold",
      children: ` ${formatNumber({
        value: selectedMileage
      })} `
    }), "total mileage with", /*#__PURE__*/jsx(Text, {
      weight: "bold",
      children: ` ${formatCurrency(Math.floor(acquisitionFee))} `
    }), "acquisition fee and", /*#__PURE__*/jsx(Text, {
      weight: "bold",
      children: ` ${formatCurrency(dueAtSigningValue)} `
    }), "due at signing."]
  });
  let modalText = `This offer is available only to qualified customers with a credit score of ${creditScoreLow} or above, at
        participating dealers by ${make?.name ?? make} through ${programEndDate}. Advertised lease rate based on
        ${selectedLeaseTerm} months, ${formatCurrency(Math.floor(dueAtSigningValue))} due at lease signing, ${formatCurrency(Math.floor(acquisitionFee))} acquisition fee, including the gross capitalized
        cost of ${formatCurrency(Math.floor(grossCapCost))}. Excludes title, taxes, registration, license fees, dealer prep and additional options.
        Total monthly payments equal ${formatCurrency(Math.floor(totalOfPayments))}. Cash due at signing includes ${formatCurrency(Math.floor(capReduction))} capitalized cost reduction,
        a required security deposit of ${formatCurrency(Math.floor(securityDeposit))}, and first month's lease payment of ${formatCurrency(Math.floor(leasePayment))}. ${formatCurrency(excessMileageCharge)} charge per
        mile over ${formatNumber({
    value: selectedMileage
  })} miles per year. Early termination fees may apply. Lessee is responsible for maintenance,
        insurance, repair, and excess wear/tear at end of lease. Lessee will not be liable for extra charges if realized
        vehicle value is lower than residual value at end of lease. Lessee may incur penalties and additional charges for
        delinquent payments. See ${dealerName} for complete details on this and other offers.`;
  let modalTitle = 'Disclaimer Details';
  let modalTriggerText = 'See more details';
  let leaseDisclaimerHasModal = true;
  const isoDate = new Date(programEndDate);
  const localizedDate = isoDate ? isoDate.toLocaleDateString('en-US') : '';
  const accelerateOnPageLeaseDisclaimer = `
        *Estimated monthly payment based on advertised price of ${formatCurrency(Math.floor(salePrice))} at
        ${formatNumber({
    value: selectedMileage
  })} miles/year for
        ${formatNumber({
    value: selectedLeaseTerm
  })} months with
        ${formatCurrency(Math.floor(dueAtSigningValue))} due at signing,
        ${formatCurrency(Math.floor(acquisitionFee))} acquisition fee, including the gross capitalized cost of
        ${formatCurrency(Math.floor(grossCapCost))}.`;
  const accelerateModalText = `
        ${accelerateOnPageLeaseDisclaimer}
        Excludes tax, title, registration, and license fees. Total monthly payments equal
        ${formatCurrency(Math.floor(totalOfPayments))}. Due at signing includes
        ${formatCurrency(Math.floor(capReduction))} capitalized cost reduction, a
        required security deposit of ${formatCurrency(Math.floor(securityDeposit))},
        and first month’s lease payment of ${formatCurrency(Math.floor(leasePayment))}.
        ${formatCurrency(Math.floor(excessMileageCharge))} charge per mile over
        ${formatNumber({
    value: selectedMileage
  })} miles per year. For
        qualified buyers. Available to approved lessees by ${lender} at
        participating dealers. Early termination fees may apply. Lessee is responsible for maintenance, insurance, repair, and excess
        wear/tear at end of lease. Lessee will not be liable for extra charges if realized vehicle value is lower
        than residual value at end of lease. Lessee may incur penalties and additional charges for delinquent
        payments. See ${dealerName} for complete details on this and other offers.
        Available through ${localizedDate}. This is a closed lease. **Federal Tax Credit
        subject to approval and not all customers will qualify. If customer chooses to receive the credit at the
        time of purchase, the credit will be applied towards the down payment.
        ${shortCustomDisclaimer ?? ' ' + shortCustomDisclaimer}`;
  switch (disclaimerKey) {
    case 'CoxAuto':
      // Esntial (has no lease)
      onPageLeaseDisclaimer = '';
      modalText = '';
      modalTitle = '';
      modalTriggerText = '';
      leaseDisclaimerHasModal = false;
      break;
    case 'BOA':
    case 'Accelerate':
      onPageLeaseDisclaimer = accelerateOnPageLeaseDisclaimer;
      modalText = accelerateModalText;
      break;
  }
  return {
    leaseDisclaimerHasModal,
    onPageLeaseDisclaimer,
    modalText,
    modalTitle,
    modalTriggerText
  };
};
export { buildLeaseDisclaimer as default };
